import { Country, Region, NOT_FOUND } from "./Country";

export const CountryEnum = Object.freeze({
	CCA: new Region(
		"CCA",
		[
			"Dominican Republic",
			"Trinidad and Tobago",
			"Guyana",
			"Jamaica",
			"Suriname",
			"Haití",
			"Curaçao",
			"The Bahamas",
			"Barbados",
			"Aruba",
			"Bonaire",
			"Puerto Rico",
		],
		"https://cca.dewalt.global/es/",
		"https://cca.stanleytools.global/es/",
		"https://cca.blackanddecker.global/es/",
		"https://hola.irwin-la.com/centroamerica/"
	),

	MIDDLE_EAST: new Region(
		"Middle East",
		[
			"Bahrain",
			"Egypt",
			"Kuwait",
			"Oman",
			"Qatar",
			"Saudi Arabia",
			"UAE",
			"META",
			"Costa Rica",
			"El Salvador",
			"Guatemala",
			"Honduras",
			"Nicaragua",
			"Panama",
		],
		"https://me.dewalt.global/",
		"https://me.stanleytools.global/",
		"https://me.blackanddecker.global/",
		NOT_FOUND
	),

	// Because there is a group called
	// "Reclame Aqui Brasil" it is necessary to
	// include both cases (Brazil and Brasil)
	BRAZIL: Country.createWithAliases(
		"Brazil",
		["Brasil"],
		"https://br.dewalt.global/",
		"https://br.stanleytools.global/pt-br/",
		"https://br.blackanddecker.global/pt-br/",
		"https://novidades.irwin.com.br/"
	),
	ARGENTINA: new Country(
		"Argentina",
		"https://ar.dewalt.global/index.php/servicio-y-ayuda/contact-us",
		"https://ar.stanleytools.global/es/",
		"https://ar.blackanddecker.global/es/",
		"http://hola.irwin.com.ar/"
	),
	ASIA: new Region("Asia"),
	CAMBODIA: new Country(
		"Cambodia",
		"https://kh.dewalt.global",
		"https://kh.stanleytools.global",
		"https://kh.blackanddecker.global",
		NOT_FOUND
	),
	CHILE: new Country(
		"Chile",
		"https://cl.dewalt.global/",
		"https://cl.stanleytools.global/es/contact-us",
		"https://cl.blackanddecker.global/es/contacto",
		"https://hola.irwin.cl/contacto/"
	),
	COLOMBIA: new Country(
		"Colombia",
		"https://co.dewalt.global/",
		"https://co.stanleytools.global/es/",
		"https://co.blackanddecker.global/",
		"https://hola.irwin.com.co/"
	),
	CURACAO: new Country("Curaçao"),
	ECUADOR: new Country(
		"Ecuador",
		"https://ec.dewalt.global",
		"https://ec.stanleytools.global",
		"https://ec.blackanddecker.global",
		NOT_FOUND
	),
	GERMANY: Country.createWithAliases(
		"Germany",
		["Black and Decker - Germany"],
		"https://www.dewalt.de/",
		"https://www.stanleyworks.de/",
		"https://www.blackanddecker.de/",
		NOT_FOUND
	),
	INDIA: new Country(
		"India",
		"https://in.dewalt.global/service-and-support/contact-us",
		"https://in.stanleytools.global/contact-us",
		"https://in.blackanddecker.global/en/contact-us",
		NOT_FOUND
	),
	INDONESIA: new Country(
		"Indonesia",
		"https://id.dewalt.global/",
		"https://id.stanleytools.global/",
		"https://id.blackanddecker.global/en/",
		NOT_FOUND
	),
	SOUTH_AFRICA: new Country(
		"South Africa",
		"https://za.dewalt.global",
		"https://za.stanleytools.global",
		"https://za.blackanddecker.global",
		NOT_FOUND
	),
	JAPAN: new Country(
		"Japan",
		"https://jp.dewalt.global/",
		"https://jp.stanleytools.global/",
		"https://jp.blackanddecker.global/ja/",
		NOT_FOUND
	),
	LAOS: new Country(
		"Laos",
		"https://la.dewalt.global",
		"https://la.stanleytools.global",
		"https://la.blackanddecker.global",
		NOT_FOUND
	),
	MALAYSIA: new Country(
		"Malaysia",
		"https://my.dewalt.global/contact-us",
		"https://my.stanleytools.global/contact-us",
		"https://my.blackanddecker.global/en/contact-us",
		NOT_FOUND
	),
	MEXICO: new Country(
		"Mexico",
		"https://mx.dewalt.global/",
		"https://mx.stanleytools.global/",
		"https://mx.blackanddecker.global/",
		"https://hola.irwin.com.mx/"
	),
	PARAGUAY: new Country(
		"Paraguay",
		"https://py.dewalt.global",
		"https://py.stanleytools.global",
		"https://py.blackanddecker.global",
		NOT_FOUND
	),
	PERU: new Country(
		"Peru",
		"https://pe.dewalt.global/",
		"https://pe.stanleytools.global/es/",
		"https://pe.blackanddecker.global/es/",
		"https://hola.irwin.com.pe/"
	),
	PHILIPPINES: new Country(
		"Philipines",
		"https://ph.dewalt.global/",
		"https://ph.stanleytools.global/",
		"https://ph.blackanddecker.global/en/",
		NOT_FOUND
	),
	SINGAPORE: new Country(
		"Singapore",
		"https://sg.dewalt.global/",
		"https://sg.stanleytools.global/contact-us",
		"https://sg.blackanddecker.global/en/contact-us",
		NOT_FOUND
	),
	SOUTH_KOREA: Country.createWithAliases(
		"South Korea",
		["Smart Order Korea"],
		"https://kr.dewalt.global/",
		"https://kr.stanleytools.global/ko-KR",
		"https://kr.blackanddecker.global/ko-KR/",
		NOT_FOUND
	),
	STANLEY_EARTH: new Country("Stanley Earth", NOT_FOUND, "https://www.stanleyearth.com/", NOT_FOUND, NOT_FOUND),
	LAG: new Country("Support LAG"),
	SURINAME: new Country("Suriname"),
	TAIWAN: new Country(
		"Taiwan",
		"https://tw.dewalt.global",
		"https://tw.stanleytools.global",
		"https://tw.blackanddecker.global",
		NOT_FOUND
	),
	THAILAND: new Country(
		"Thailand",
		"https://th.dewalt.global/th/",
		"https://th.stanleytools.global/",
		"https://th.blackanddecker.global/th-TH/",
		NOT_FOUND
	),
	TURKEY: new Country(
		"Turkey",
		"https://tr.dewalt.global/",
		"https://tr.stanleytools.global/",
		"https://tr.blackanddecker.global/",
		NOT_FOUND
	),
	URUGUAY: new Country(
		"Uruguay",
		"https://uy.dewalt.global",
		"https://uy.stanleytools.global",
		"https://uy.blackanddecker.global",
		NOT_FOUND
	),
	VENEZUELA: new Country(
		"Venezuela",
		"https://ve.dewalt.global/",
		"https://ve.stanleytools.global",
		"https://ve.blackanddecker.global",
		NOT_FOUND
	),
	VIETNAM: new Country("Vietnam"),
	OTHERS: new Country("Others"),
});
// INSIDE OTHERS:
// Management Team, Data, Demo, English Speaking Arab Group, other markets,
// Other Markets out of support, Testing, Test_Views, Total Care, TPCO, TPCO_P,
// TPCO_S, TPROA, TPTUR
